import { Pagination, useMantineTheme } from '@mantine/core'
import { useMediaQuery } from '@mantine/hooks'
import {
  IconArrowBarToLeft,
  IconArrowBarToRight,
  IconArrowLeft,
  IconArrowRight,
  IconGripHorizontal,
} from '@tabler/icons-react'

const TablePagination: React.FC<{
  count: number
  page: number
  onPageChange?: (newPage: number) => void
}> = ({ count, page, onPageChange = () => {} }) => {
  const theme = useMantineTheme()
  const isMobile = useMediaQuery(`(max-width: ${theme.breakpoints.sm})`)
  return (
    <>
      <Pagination
        style={{ marginTop: 10 }}
        size={isMobile ? 'sm' : 'md'}
        boundaries={isMobile ? 0 : 1}
        withControls={false}
        total={count}
        value={page}
        nextIcon={IconArrowRight as any}
        previousIcon={IconArrowLeft as any}
        firstIcon={IconArrowBarToLeft as any}
        lastIcon={IconArrowBarToRight as any}
        dotsIcon={IconGripHorizontal as any}
        onChange={number => {
          onPageChange(number)
        }}
      />
    </>
  )
}

export default TablePagination
